import { React, useState, useEffect } from "react";

import { useHistory, Link, useLocation } from "react-router-dom";

import axios from "axios";

import { connect } from "react-redux";

import { url_143 } from "../../../../../../../custom_utilities/api_services";

import { readPersistedExerciseSummary } from "../exercisePaperIdUtils";

import images from "../../../../../../../utilities/images/images";

import uiActions from "../../../../../../../redux/ui/action";

import HeaderComponent from "../../../../../structure_components/desktop_screens/header_component/header_component";

import Mobile_header_component from "../../../../../structure_components/mobile_screens/mobile_header_component/mobile_header_component";

import MobileLeftSideBarComponent from "../../../../../structure_components/mobile_screens/mobile_left_sideBar_component/mobile_left_sideBar_component";

import Mobile__right_sideBar_component from "../../../../../structure_components/mobile_screens/mobile_right_sideBar_component/mobile__right_sideBar_component";

import "./ExerciseSummary.scss";



const ExerciseSummary = (props) => {

  const {

    startLoading,

    finishLoading,

    testResultData,

    userData,

    userPreference,

    history,

  } = props;



  const location = useLocation();

  const historys = useHistory();

  const [state, setState] = useState();

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);



  const paperId =

    location.state?.paper_id ??

    testResultData?.paper_id ??

    testResultData?.id ??

    null;

  const localSummary =

    location.state?.localSummary ??

    testResultData?.localSummary ??

    readPersistedExerciseSummary() ??

    null;



  useEffect(() => {

    if (localSummary) {

      setState({ data: localSummary });

      return;

    }

    getExerciseSummary();

  }, []);



  useEffect(() => {

    const setWidth = () => setWindowWidth(window.innerWidth);

    window.addEventListener("resize", setWidth);

    return () => window.removeEventListener("resize", setWidth);

  }, []);



  const getExerciseSummary = async () => {

    if (!paperId) {

      finishLoading();

      return;

    }



    startLoading();

    try {

      const response = await axios.post(url_143, { paper_id: paperId });

      if (response.data.status === 200) {

        setState(response.data);

      }

    } catch (error) {

      console.log(error);

    } finally {

      finishLoading();

    }

  };



  const data1 = state?.data;



  const formatMarksDisplay = (summary) => {

    if (!summary || summary.total_marks == null) {

      return "-";

    }



    const earnedMarks =

      summary.earned_marks ??

      summary.obtained_marks ??

      (summary.correct_answer != null ? summary.correct_answer * 4 : null);



    if (earnedMarks == null) {

      return summary.total_marks;

    }



    return `${earnedMarks} / ${summary.total_marks}`;

  };



  const scorePercentage =

    data1?.score_percentage != null ? Number(data1.score_percentage) : 0;



  const summaryStats = [

    {

      label: "Total Questions",

      value: data1?.total_questions ?? "-",

      variant: "neutral",

    },

    {

      label: "Total Marks",

      value: formatMarksDisplay(data1),

      variant: "marks",

    },

    {

      label: "Correct Answers",

      value: data1?.correct_answer ?? "-",

      variant: "success",

    },

    {

      label: "Incorrect Answers",

      value: data1?.incorrect_answer ?? "-",

      variant: "danger",

    },

  ];



  return (

    <>

      <div className="behaviourWrapper">
        {windowWidth <= 480 ? (
          <>
            <MobileLeftSideBarComponent />
            <Mobile_header_component
              userPreference={userPreference}
              userData={userData}
            />
            <Mobile__right_sideBar_component history={history} />
          </>
        ) : (
          <HeaderComponent history={history} />
        )}

        <div className="exercise-summary-page">
          <div className="exercise-summary-page__container">

          <header className="exercise-summary-page__header">

            <Link className="exercise-summary-page__back-btn" to="/topic_component">

              <img src={images.m2_backBtn} alt="Back" />

            </Link>

            <div className="exercise-summary-page__title-block">

              <h2>Test Summary</h2>

              <p>Your exercise performance at a glance</p>

            </div>

          </header>



          <div className="exercise-summary-page__panel">

            <div className="exercise-summary-page__score-hero">

              <div

                className="exercise-summary-page__score-ring"

                style={{ "--score": scorePercentage }}

              >

                <span className="exercise-summary-page__score-value">

                  {data1?.score_percentage != null

                    ? `${data1.score_percentage}%`

                    : "-"}

                </span>

              </div>

              <div className="exercise-summary-page__score-copy">

                <h3>Overall Score</h3>

                <p>

                  You answered {data1?.correct_answer ?? 0} of{" "}

                  {data1?.total_questions ?? 0} questions correctly.

                </p>

              </div>

            </div>



            <div className="exercise-summary-page__stats-grid">

              {summaryStats.map((stat) => (

                <div

                  key={stat.label}

                  className={`exercise-summary-page__stat-card exercise-summary-page__stat-card--${stat.variant}`}

                >

                  <p className="exercise-summary-page__stat-label">{stat.label}</p>

                  <p className="exercise-summary-page__stat-value">{stat.value}</p>

                </div>

              ))}

            </div>

          </div>



          <div className="exercise-summary-page__actions">

            <button

              type="button"

              className="exercise-summary-page__cta"

              onClick={() => historys.push("/topic_component")}

            >

              Back to Topic

            </button>

          </div>
        </div>
      </div>
      </div>

    </>

  );

};



const mapStateToProps = (state) => ({

  loader: state.ui.loader,

  testResultData: state.userTestsExercisesData.testResultData,

  userData: state.auth.user,

  userPreference: state.userPreference,

});



const mapDispatchToProps = (dispatch) => ({

  startLoading: () => dispatch(uiActions.startLoading()),

  finishLoading: () => dispatch(uiActions.finishLoading()),

});



export default connect(mapStateToProps, mapDispatchToProps)(ExerciseSummary);

